import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants';
import Logo from '../assets/giff.gif';



const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.5,
  });
  return (
    <section className='section bg-[#111727] '  ref={ref}>
     <div className='container mx-auto'>
      <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen'>
        {/* img */}
        <motion.div
        variants={fadeIn('right',0.3)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false,amount:0.3}}
        className='flex-1  bg-contain bg-no-repeat h-[640px] min-blend-lighten bg-top' >
          <img src={Logo} alt='GIF' />
        </motion.div>

        {/* text */}
        <motion.div
        variants={fadeIn('left',0.5)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false,amount:0.7}}
         className='flex-1'>
          
          <h2 className='h2 text-accent text-6xl' id='about'>Join Us.</h2>
          <h3 className='h3 mb-4 text-gray-300'>as we paint a masterpiece to express our love and support for the incredible journeys fueled by the magic of 
@JupiterExchange</h3>
          
          {/* stats */}
          {/* <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
            <div>
              <div className='text-[40px] font-tertiary text-gradient mb-2'>
                {inView?
                <CountUp start={0} end={4} duration={3}/> : 
                null}
              </div>
              <div className='font-primary text-sm tracking-[2px]'>
                Years of <br />
                Experience
              </div>
            </div>

             <div>
              <div className='text-[40px] font-tertiary text-gradient mb-2'>
                {inView?
                <CountUp start={0} end={4} duration={3}/> : 
                null}
              </div>
              <div className='font-primary text-sm tracking-[2px]'>
                Years of <br />
                Experience
              </div>
            </div>

             <div>
              <div className='text-[40px] font-tertiary text-gradient mb-2'>
                {inView?
                <CountUp start={0} end={4} duration={3}/> : 
                null}
              </div>
              <div className='font-primary text-sm tracking-[2px]'>
                Years of <br />
                Experience
              </div>
            </div>
          </div> */}
          {/* <div className='flex gap-x-6 items-center'>
            <button className='btn btn-lg'>Contact me</button>
            <a href='#' className='text-gradient btn-link'> My Portfolio</a>
          </div> */}
        </motion.div>
      </div>
     </div>
    </section>
  );

};

export default About;
